import { EASY, ELITE, OVERWHELMING, STANDARD } from "../../difficulty.config";
import { APPEARANCE } from "../defaults/appearance";

export const anansi = {
  [EASY]: {
    STR: 4,
    DEX: 8,
    CON: 8,
    WIL: 6,
    INT: 6,
    CHA: 0,
    attackSkill: "+3 (or +8 vs opponents not directly targeting them)",
    damage: "(1D8)+5",
    wounds: 1,
    awareness: 5,
    armor: 0,
    defense: 0,
    abilities: [],
    roleProperties: [],
    appearance: APPEARANCE.QUADRUPED,
  },
  [STANDARD]: {
    STR: 10,
    DEX: 12,
    CON: 9,
    WIL: 10,
    INT: 10,
    CHA: 0,
    attackSkill: "+5 (or +10 vs opponents not directly targeting them)",
    damage: "(1D8)+5",
    wounds: 1,
    awareness: 10,
    armor: 0,
    defense: 2,
    abilities: ["Venom"],
    roleProperties: [
      "The Anansi shoots a venomous dart, applying the Poisoned IV condition",
    ],
    appearance: APPEARANCE.QUADRUPED,
  },
  [ELITE]: {
    STR: 10,
    DEX: 16,
    CON: 10,
    WIL: 12,
    INT: 10,
    CHA: 0,
    attackSkill: "+8 (or +13 vs opponents not directly targeting them)",
    damage: "(2D8)+5",
    wounds: 2,
    awareness: 15,
    armor: 0,
    defense: 5,
    abilities: ["Venom", "Immune to all Conditions"],
    roleProperties: [
      "The Anansi shoots a venomous dart, applying the Poisoned IV condition",
    ],
    appearance: APPEARANCE.QUADRUPED,
  },
  [OVERWHELMING]: {
    STR: 14,
    DEX: 16,
    CON: 14,
    WIL: 14,
    INT: 12,
    CHA: 0,
    attackSkill: "+10 (or +15 vs opponents not directly targeting them)",
    damage: "(2D10)",
    wounds: 2,
    awareness: 20,
    armor: 0,
    defense: 5,
    abilities: [
      "Venom",
      "Immune to all Conditions",
      "Can initiate attacks 3 times/round",
    ],
    roleProperties: [
      "The Anansi shoots a venomous dart, applying the Poisoned IV condition",
    ],
    appearance: APPEARANCE.QUADRUPED,
  },
};
